import DOMPurify from 'dompurify'
import type { Directive } from 'vue'

const IFRAME_CONFIG = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'width', 'height', 'title', 'loading', 'style'],
}

const safeHtmlDirective: Directive<HTMLElement, string> = {
  mounted(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value ?? '', IFRAME_CONFIG)
  },
  updated(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value ?? '', IFRAME_CONFIG)
  }
}

export default safeHtmlDirective
